import { render } from "./HeaderUserDropdown.vue?vue&type=template&id=b4c414ae&scoped=true"
import script from "./HeaderUserDropdown.vue?vue&type=script&lang=js"
export * from "./HeaderUserDropdown.vue?vue&type=script&lang=js"

import "./HeaderUserDropdown.vue?vue&type=style&index=0&id=b4c414ae&scoped=true&lang=css"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4c414ae"]])

export default __exports__